import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { CorpHierarchyModel } from 'src/app/models';
import { sluggify } from 'src/app/utils/strings/string.utils';
import { ActionProgressComponent } from 'src/app/modules/shared/action-progress/action-progress.component';
import { CorpHierarchiesService } from 'src/app/services/firestore';

@Component({
  selector: 'app-add-corp-hierarchy-modal',
  templateUrl: './add-corp-hierarchy-modal.component.html',
  styleUrls: ['./add-corp-hierarchy-modal.component.scss'],
})
export class AddCorpHierarchyModalComponent implements OnInit {
  corpHierarchy: CorpHierarchyModel;
  corpId: string;
  loading: boolean;
  corpsLength: number;

  @ViewChild(ActionProgressComponent) actionProgress: ActionProgressComponent;
  constructor(
    private corpHierarchiesService: CorpHierarchiesService,
    public modal: BsModalRef,
    private toaster: ToastrService,
    private authService: AuthService,
    options: ModalOptions,
  ) {
    this.corpHierarchy = new CorpHierarchyModel();

    if (!options.initialState) {
      return;
    }
    const { corpId, corpsLength } = options.initialState as any;
    this.corpId = corpId;
    this.corpsLength = corpsLength;
  }

  async ngOnInit() {
    const user = await this.authService.currentUser;
    if (!user) {
      return;
    }

    this.corpHierarchy.lastTouchedBy = user.uid;
  }

  changeSystemName() {
    this.corpHierarchy.systemName = sluggify(this.corpHierarchy.label);
  }

  async save() {
    this.corpHierarchy.order = this.corpsLength + 1;
    this.actionProgress.start();
    this.loading = true;
    try {
      await this.corpHierarchiesService.addCorpHierarchy(this.corpId, this.corpHierarchy);
      this.modal.hide();
      this.toaster.success('Corp Hierarchy Saved');
    } catch (error) {
      this.toaster.error(error);
    }
    this.loading = false;
    this.actionProgress.complete();
  }
}
